import { RotateSolidIcon } from '@components/Icons';

import styles from './Loader.module.scss';

interface LoaderProps {
  message?: string;
  fixed?: boolean;
  testId?: string;
}

export const Loader = ({ message, fixed, testId }: LoaderProps) => {
  return (
    <div className={fixed ? styles.container : undefined} data-testid={testId}>
      <div className={styles.loaderPanel}>
        <RotateSolidIcon className={styles.loader} />
        <h2>{message || 'Loading'}</h2>
      </div>
      <div className={styles.backDrop}></div>
    </div>
  );
};
